import each from "lodash/each";

enum Direction {
  "Next" = 0,
  "Prev" = -1
}

export const ThumbnailGallery: Function = () => {
  const tgs: NodeList = document.querySelectorAll(".tg");

  each(tgs, tg => {
    const thumbs: NodeList[] = tg.querySelectorAll(".tg__thumb");
    const nextEl: Element = tg.querySelector(".tg__navNext");
    const prevEl: Element = tg.querySelector(".tg__navPrev");

    if (!thumbs) return;

    each(thumbs, thumb => {
      thumb.addEventListener("click", () => {
        setActive(thumb, tg);
      });
    });

    prevEl && prevEl.addEventListener("click", () => navigate(tg, -1));
    nextEl && nextEl.addEventListener("click", () => navigate(tg, 1));
  });
};

function navigate(group: Element, direction: Direction): void {
  const currActive: Element = group.querySelector(".tg__thumb--active");
  let nextEl = null;

  if (direction === Direction.Prev) {
    nextEl = currActive.previousElementSibling || group.querySelector(".tg__thumb:last-child");
  } else {
    nextEl = currActive.nextElementSibling || group.querySelector(".tg__thumb:first-child");
  }
  setActive(nextEl, group);
}

function setActive(thumb: Element, group: Element) {
  const selected: Element = group.querySelector(".tg__image--selected");
  const selectedImage = selected.getElementsByTagName("img");
  const currActive: Element = group.querySelector(".tg__thumb--active");
  const title: Element = selected.querySelector(".tg__imageTitle");

  if (currActive) {
    currActive.classList.remove("tg__thumb--active");
  }

  if (selectedImage.length) {
    selectedImage[0].setAttribute("src", thumb.getAttribute("data-full"));

    if (title) {
      const titleText: string = thumb.getAttribute("data-title");

      if (titleText && titleText.length) {
        title.textContent = titleText;
        title.classList.add("tg__imageTitle--show");
      } else {
        title.textContent = "";
        title.classList.remove("tg__imageTitle--show");
      }
    }
  }

  thumb.classList.add("tg__thumb--active");
}
